import React from 'react';
import Blocks from 'editorjs-blocks-react-renderer';
import { frfr_alien_editorjs_editorjs_renderable_data_validator_quick_incomplete } from '../utils/frfr-alien-editorjs-utils';


// https://www.npmjs.com/package/editorjs-blocks-react-renderer
// https://github.com/moveyourdigital/editorjs-blocks-react-renderer

/*
PROPS:
props.editorjs_renderable_data

*/

//
const FrfrAlienEditorjsRendererV1 = (props) => {
  return (
    <>
      {
        frfr_alien_editorjs_editorjs_renderable_data_validator_quick_incomplete(props.editorjs_renderable_data) === true ? (
          <Blocks
            data={props.editorjs_renderable_data}
            config={{
              image: {
                className: "novo-img-class123 w-full max-w-screen-md",
                actionsClassNames: {
                  stretched: "w-full h-80 object-cover",
                  withBorder: "border border-2",
                  withBackground: "p-2",
                }
              },

            }}
          />
        ) : (
          <p className="text-red">DATA IS NOT READY FOR RENDER YET</p>
        )
      }
    </>
  );
};

export default FrfrAlienEditorjsRendererV1;